module.exports = __webpack_public_path__ + "img/baf046b.png";